import React from 'react';
import './Blog.css';

const Blog = () => {
    const blogPosts = [
        {
            id: 1,
            title: "The Importance of Regular Health Check-ups",
            excerpt: "Regular health check-ups are crucial for early detection of potential health issues. Learn why scheduling routine examinations can save lives and improve your quality of life.",
            content: "Regular health check-ups play a vital role in maintaining good health and preventing serious illnesses. These routine examinations allow healthcare professionals to detect potential health issues early, when they are most treatable. At JDS Hospitals, we recommend annual check-ups for adults and more frequent visits for those with chronic conditions or risk factors.",
            author: "Dr. Rajesh Kumar",
            date: "2024-01-15",
            category: "Health Tips",
            readTime: "3 min read",
            image: "/images/blog/health-checkup.jpg"
        },
        {
            id: 2,
            title: "Understanding Heart Health: Prevention is Better Than Cure",
            excerpt: "Heart disease remains a leading cause of death worldwide. Discover the key factors that contribute to heart health and how you can protect your cardiovascular system.",
            content: "Heart disease affects millions of people worldwide and is often preventable through lifestyle modifications and regular medical care. Key factors for maintaining heart health include maintaining a healthy weight, regular exercise, balanced diet, stress management, and avoiding smoking. Regular cardiovascular screenings and blood pressure monitoring are essential for early detection.",
            author: "Dr. Priya Sharma",
            date: "2024-01-12",
            category: "Cardiology",
            readTime: "4 min read",
            image: "/images/blog/heart-health.jpg"
        },
        {
            id: 3,
            title: "Mental Health Matters: Breaking the Stigma",
            excerpt: "Mental health is just as important as physical health. Learn about common mental health conditions and the importance of seeking professional help when needed.",
            content: "Mental health encompasses our emotional, psychological, and social well-being. It affects how we think, feel, and act. Common mental health conditions include anxiety, depression, and stress-related disorders. Early intervention and professional support can significantly improve outcomes. At JDS Hospitals, our mental health services provide comprehensive care in a supportive environment.",
            author: "Dr. Anjali Mehta",
            date: "2024-01-10",
            category: "Mental Health",
            readTime: "5 min read",
            image: "/images/blog/mental-health.jpg"
        },
        {
            id: 4,
            title: "Advances in Cancer Treatment at JDS Hospitals",
            excerpt: "Explore the latest advancements in cancer treatment and how JDS Hospitals is leading the way in providing comprehensive oncology care.",
            content: "Cancer treatment has evolved significantly with advances in medical technology and research. At JDS Hospitals, we offer state-of-the-art treatments including chemotherapy, radiation therapy, immunotherapy, and targeted therapies. Our multidisciplinary team approach ensures personalized treatment plans for each patient, combining the latest medical advancements with compassionate care.",
            author: "Dr. Vikram Singh",
            date: "2024-01-08",
            category: "Oncology",
            readTime: "6 min read",
            image: "/images/blog/cancer-treatment.jpg"
        },
        {
            id: 5,
            title: "Pediatric Care: Ensuring Healthy Futures",
            excerpt: "Children's health requires specialized attention. Discover how JDS Hospitals provides comprehensive pediatric care from infancy through adolescence.",
            content: "Pediatric care encompasses the physical, mental, and emotional health of children from birth through adolescence. Regular check-ups, vaccinations, and early intervention for developmental issues are crucial. Our pediatric department at JDS Hospitals offers comprehensive services including newborn care, immunization programs, and specialized treatment for childhood illnesses.",
            author: "Dr. Meera Patel",
            date: "2024-01-05",
            category: "Pediatrics",
            readTime: "4 min read",
            image: "/images/blog/pediatric-care.jpg"
        },
        {
            id: 6,
            title: "The Role of Nutrition in Disease Prevention",
            excerpt: "A balanced diet is fundamental to good health. Learn how proper nutrition can prevent chronic diseases and support overall well-being.",
            content: "Nutrition plays a critical role in maintaining health and preventing chronic diseases. A balanced diet rich in fruits, vegetables, whole grains, and lean proteins provides essential nutrients for optimal body function. Poor nutrition can lead to obesity, diabetes, heart disease, and other health issues. Our nutrition counseling services help patients develop healthy eating habits for long-term wellness.",
            author: "Dr. Sanjay Gupta",
            date: "2024-01-03",
            category: "Nutrition",
            readTime: "4 min read",
            image: "/images/blog/nutrition.jpg"
        },
        {
            id: 7,
            title: "Emergency Care: What You Need to Know",
            excerpt: "Understanding when to seek emergency care can be life-saving. Learn about common emergency situations and how JDS Hospitals handles critical cases.",
            content: "Emergency care requires quick thinking and immediate medical attention. Common emergencies include heart attacks, strokes, severe injuries, and acute illnesses. JDS Hospitals maintains a 24/7 emergency department equipped with advanced life support systems and experienced medical staff. Knowing when to call emergency services can make the difference between life and death.",
            author: "Dr. Ramesh Jain",
            date: "2024-01-01",
            category: "Emergency Care",
            readTime: "3 min read",
            image: "/images/blog/emergency-care.jpg"
        },
        {
            id: 8,
            title: "The Future of Healthcare Technology",
            excerpt: "Technology is revolutionizing healthcare. Explore how digital innovations are improving patient care and medical outcomes at JDS Hospitals.",
            content: "Healthcare technology continues to advance rapidly, offering new ways to diagnose, treat, and monitor patients. From telemedicine and electronic health records to AI-assisted diagnostics and robotic surgery, these innovations are making healthcare more accessible and effective. JDS Hospitals embraces cutting-edge technology to provide the best possible care for our patients.",
            author: "Dr. Arjun Rao",
            date: "2023-12-28",
            category: "Technology",
            readTime: "5 min read",
            image: "/images/blog/healthcare-tech.jpg"
        }
    ];

    return (
        <div className="blog-container">
            <div className="container">
                <div className="blog-content">
                    <div className="posts-grid">
                        {blogPosts.map(post => (
                            <div key={post.id} className="post-card">
                                <div className="post-header">
                                    <div className="post-category">{post.category}</div>
                                    <div className="post-date">{new Date(post.date).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</div>
                                </div>

                                <h2 className="post-title">{post.title}</h2>

                                <p className="post-excerpt">{post.excerpt}</p>

                                <div className="post-meta">
                                    <div className="author-info">
                                        <span className="author-name">By {post.author}</span>
                                        <span className="read-time">{post.readTime}</span>
                                    </div>
                                    <button className="read-more-link">Read Full Article →</button>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Blog;
